export var PlayerFeedbackSearchTimeType;
(function (PlayerFeedbackSearchTimeType) {
    PlayerFeedbackSearchTimeType[PlayerFeedbackSearchTimeType["CREATED_AT"] = 1] = "CREATED_AT";
    PlayerFeedbackSearchTimeType[PlayerFeedbackSearchTimeType["UPDATED_AT"] = 2] = "UPDATED_AT";
})(PlayerFeedbackSearchTimeType || (PlayerFeedbackSearchTimeType = {}));
//# sourceMappingURL=PlayerFeedbackSearchTimeType.js.map